import React from 'react';
import styled from 'styled-components';
import { IQuadrantReportState } from '../../../data/providers/reports/quadrantReportProvider';
import { Entity } from '../../../data/types';
import { Column } from '../../layout/Column';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import { GraphContainer } from '../../shared/graphs/GraphContainer';
import { Icon } from '../../shared/Icon';
import { Notable } from '../../shared/pdf/Notable';
import { EPdfMode, isPdf, shouldInvert } from '../../shared/pdf/Pdf';
import { QuadrantGraph } from './QuadrantGraph';

interface IProps {
  reportState: IQuadrantReportState;
  pdfMode?: EPdfMode;
  quartileColors: string[];
  entity: Entity;
}

export const QuadrantGraphCard = (props: IProps): React.ReactElement => {
  return (
    <PdfCardWrapper className='avoid-break' pdf={isPdf(props.pdfMode)}>
      <Notable pdf={isPdf(props.pdfMode)}>
        <Card
          inverse={shouldInvert(props.pdfMode)}
          noTopRadius
          style={isPdf(props.pdfMode) ? { overflow: 'visible', height: 'auto' } : undefined}
        >
          <Column>
            <CardBody withoutFooter notScrollable={isPdf(props.pdfMode)}>
              <GraphContainer
                inverse={shouldInvert(props.pdfMode)}
                style={isPdf(props.pdfMode) ? { height: 'auto' } : undefined}
              >
                <PopulationInfo
                  entity={props.entity}
                  populationData={props.reportState.populationResult}
                  populationSettings={props.reportState.comparisonPopulation}
                />
                <QuadrantGraph
                  reportState={props.reportState}
                  pdfMode={props.pdfMode}
                  quartileColors={props.quartileColors}
                />
              </GraphContainer>
            </CardBody>
          </Column>
        </Card>
      </Notable>
    </PdfCardWrapper>
  );
};

const PdfCardWrapper = styled.div<{ pdf?: boolean }>`
  flex: 1;
`;

interface IPopulationInfoProps {
  populationData: IQuadrantReportState['populationResult'];
  populationSettings: IQuadrantReportState['comparisonPopulation'];
  entity: Entity;
}

const PopulationInfo = (props: IPopulationInfoProps): React.ReactElement => {
  const entityLabel =
    props.populationSettings.entity.value !== 'self'
      ? props.populationSettings.entity.label
      : props.entity.name;

  return (
    <Container>
      <Column>
        <Container>
          <Icon
            name='add'
            size='small'
            style={{ color: 'var(--color-primary)' }}
          />
          <div style={{ flex: 1, whiteSpace: 'nowrap' }}>{entityLabel}</div>
        </Container>
      </Column>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`;
